import { Cirus } from "@/classes/Http";
import store from "@/store";
import { AxiosResponse } from "axios";
import { Image } from "../Instance";
export function getCustomerProfile() {
    const path = '/customer/me';
    return Cirus.get(path);
}

class ProductBrand {
    id!: string;
    name!: string;
    logo!: Image;
}

class AverageRating {
    name!: string;
    score = 0;
    max = 5;
}

class RatingOption {
    id!: string;
    name!: string;
    max = 5;
}

export class GetProductInfoResponse {
    id!: string;
    name!: string;
    description!: string;
    available!: boolean;
    price!: number;
    price_with_off!:number;
    off_percent!: number;
    currency= 'تومان';
    image: Image = new Image();
    images!: Image[];
    brand?: ProductBrand;
    category_id!: string;
    category = '';
    rating_score= '0';
    max_rating_score = 5;
    rating_averages: AverageRating[] = [];
    rating_options: RatingOption[] = [];
    rating_count = '0';
    comments_count = '0';
    favorite = false;
    remaining = 0;
    barcode = '';
    predicted_percent!: number;
    suggested: boolean;
}


class CartItemOption {
    id!: string;
    title!: string;
    value!: string;
}


export class CartItemResponse extends GetProductInfoResponse {
    cart_item_id!: string;
    count!: number;
    remaining!: number;
    price_choice!: CartItemOption;
    other_choices!: CartItemOption[];
}

class AddressLocation {
    countryId!: number;
    stateId!: number;
    cityId!: number;
    verbal!: string;
}

enum DeliveryStatus {
    IN_INVENTORY = 0,
    SENDING = 1,
    SENT = 2,
    DELIVERED = 3,
    RETURNED = 4
}

class DeliveryAddress {
    location!: AddressLocation;
    position!: Position;
    phone!: string;
    mobile!: string;
    postcode!: string;
    receiver_name!: string;
    id_card!: string;
}
enum DeliveryType {
    INSTANCE_DOOR = 0,
    CUSTOMER_DOOR = 1,
    THIRD_PERSON = 2
}

class CartDelivery {
    total!: number;
    address!: DeliveryAddress;
    status!: DeliveryStatus;
    type!: DeliveryType;
}

export class GetCustomerCartResponse {

    items!: CartItemResponse[];
    total_price!: number;
    total_price_with_off!: number;
    payment_method?: PaymentMethod;
    delivery?: CartDelivery;
}


export function getCustomerCart(token: string): Promise<AxiosResponse<GetCustomerCartResponse>>{
    const path = '/customer/cart';
    return Cirus.get(path, {}, {}, true, process.env.VUE_APP_baseURL, token);
}

class AddToCartRequest {
    product_id!: string;
    price_id?: string|null;
    choices?: string[] = [];
    count?: number = 1;
}

export function addToCart(body: AddToCartRequest) {
    const path = '/customer/cart';
    const res = Cirus.put(path, body);
    setTimeout(() => {
        store.dispatch('updateCart')
    }, 1000);
    return res;
}


export function deleteCartItem(cart_id: string) {
    const path = '/customer/cart/'+cart_id;
    const res =  Cirus.delete(path);
    setTimeout(() => {
        store.dispatch('updateCart')
    }, 1000);
    return res;
}

class UpdateCartItemParam {
    cart_item_id!: string;
    count!: number;
}

export function updateCartItem(param: UpdateCartItemParam) {
    const path = '/customer/cart/';
    const res =  Cirus.post(path, param);
    setTimeout(() => {
        store.dispatch('updateCart')
    }, 1000);
    return res;
}

class Position {
    latitude!: string;
    longitude!: string;
}

class Location {
    countryId!: number;
    country_name!: string;
    country_native_name!: string;
    stateId!: number;
    state_name!: string;
    state_native_name!: string;
    cityId!: number;
    city_name!: string;
    city_native_name!: string;
    verbal!: string;
  }

export class GetCustomerAddressResponse {
    id!: string;
    title!: string;
    description!: string;
    location!: Location;
    position!: Position;
    receiver_name!: string;
    phone!: string;
    mobile!: string;
    id_card!: string;
    postcode!: string;
}

export function getCustomerAddresses(): Promise<AxiosResponse<GetCustomerAddressResponse[]>> {
    const path = '/customer/addresses/';
    return Cirus.get(path);
}


class createAddressLocation {
    countryId!: number;
    stateId!: number;
    cityId!: number;
    verbal!: string;
}

class CreateCustomerAddressRequest {
    title?: string|null;
    description?: string;
    location!: createAddressLocation;
    position?: Position;
    receiver_name?: string;
    phone?: string;
    mobile!: string;
    id_card?: string;
    postcode?: string;
  }

export function createCustomerAddress(body: CreateCustomerAddressRequest): Promise<AxiosResponse<GetCustomerAddressResponse[]>> {
    const path = '/customer/address/';
    return Cirus.put(path, body);
}


export function deleteCustomerAddress(id: string): Promise<AxiosResponse<GetCustomerAddressResponse[]>> {
    const path = '/customer/address/'+id;
    return Cirus.delete(path);
}

export class Address {
    id_card?: string;
    location: Location = new Location();
    mobile!: string;
    phone?: string;
    position?: Position = new Position();
    postcode?: string;
    reciver_name?: string;
}

export enum PaymentMethod {
    tayeh = "tayeh",
    manual = "manual"
}

class SetCustomerCartDeliveryBody {
    address!: Address;
    payment_method: PaymentMethod = PaymentMethod.manual;
}

export function setCustomerCartDelivery(body: SetCustomerCartDeliveryBody): Promise<AxiosResponse<GetCustomerAddressResponse[]>> {
    const path = '/customer/cart/delivery';
    return Cirus.post(path, body);
}

export class getPaymentUrlResponse {
    err?: string;
    payment_url?: string;
}
export function getCustomerCartPaymentUrl(token: string): Promise<AxiosResponse<getPaymentUrlResponse>> {
    const path = '/customer/cart/pay';
    return Cirus.get(path, {}, {}, true, process.env.VUE_APP_baseURL, token);
}